import { Component,  Input, Output } from '@angular/core';
import { EditFileInfo, EditFileResult, FileInfoComponent } from './file-info.component';
import { JoiFile } from 'globals/store/files.model';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EventEmitter } from '@angular/core';
import { FileLinkComponent, FileType } from './file-link.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'url-handler',
    template: `
<file-link *ngIf="url"
  [file]="{ linkUrl: url, filename: name, created: null }"
  [type]="type"
  [readOnly]="true"
  [hideByline]="true"
  (openFile)="openFileDialog($event)"
></file-link>
<div class="empty-text" *ngIf="!url">No {{ type }} Link</div>
<div class="upload_panel text_link" *ngIf="!readOnly">
  <label (click)="openFileDialog($event)">{{ (url ? 'Change ' : '+ Add ') + type + ' LINK' }}</label>
</div>
`,
    styleUrls: ['./file-handler.component.scss'],
    standalone: true,
    imports: [FileLinkComponent, CommonModule],
})
export class UrlHandlerComponent {
  @Input() url
  @Input() name
  @Input() type: FileType = 'Asset'
  @Input() readOnly = true 
  @Output() changeUrl: EventEmitter<string> = new EventEmitter()

  constructor(private dialog: MatDialog) {}

  async openFileDialog(event) {
    const { x, y } = event.target.getBoundingClientRect();
    const fakeFile: JoiFile = { created: null, linkUrl: this.url || '' }

    const data: EditFileInfo = { type: this.type, item: fakeFile, x, y, noName: true }
    console.log(data)
    const result = await openDialogGetResult<EditFileResult>(this.dialog, FileInfoComponent, { width: '300px', disableClose: true, data, backdropClass: 'clear' })
    console.log({ result })
    if (result) this.changeUrl.emit(result.action === 'delete' ? '' : result.item.linkUrl)
  }
}



